import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const EligibilitySection = () => {
  const { t } = useTranslation();
  const items = t("eligibility.items", { returnObjects: true }) as string[];

  return (
    <section id="eligibility" className="py-20 lg:py-28 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl sm:text-4xl font-display font-bold mb-3">
              {t("eligibility.title")}
            </h2>
            <p className="text-lg font-display italic text-pagoda-gold">
              {t("eligibility.subtitle")}
            </p>
          </motion.div>

          <div className="space-y-4">
            {items.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex items-start gap-3 p-4 rounded-lg bg-primary-foreground/5 border border-primary-foreground/10"
              >
                <CheckCircle className="h-5 w-5 text-pagoda-gold flex-shrink-0 mt-0.5" />
                <span className="text-sm font-body text-primary-foreground/90">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilitySection;
